import { styled } from '../jss-style';
import menuStyle from './menu';

const useMenuStyle = styled(menuStyle, 'menu');
export { menuStyle, useMenuStyle };
export default useMenuStyle;
